import { TagListItem } from '@/models/common/tag-list-item.model';

export type DocumentListItemResponse = {
  playerId: string;
  playerEmail: string;
  whitelabelSlug: string;
  lastPendingFileUploadedAt: number;
  playerTagList: DocumentPlayerTagListItem[];
  documentModerationAction: string;
  maskedFieldList?: string[];
  pendingFileCount?: number;
}

export type DocumentListItem = {
  playerId: string;
  playerEmail: string;
  whitelabelSlug: string;
  lastPendingFileUploadedAt: string;
  playerTagList: DocumentPlayerTagListItem[];
  documentModerationAction: string | null;
  maskedFieldList?: string[];
  pendingFileCount?: number;
  actionType?: string;
  actionLabel?: string;
}

export type DocumentPlayerTagListItem = TagListItem;

export enum DocumentColumnProperties {
  CREATED_AT = 'lastPendingFileUploadedAt',
  WHITELABEL_SLUG = 'whitelabelSlug',
  PLAYER = 'player',
  PLAYER_EMAIL = 'playerEmail',
  PLAYER_ID = 'playerId',
  PLAYER_TAG_LIST = 'playerTagList',
  FILES = 'pendingFileCount',
  ACTIONS = 'actions',
  ACTION_TYPE = 'actionType',
  ACTION_LABEL = 'actionLabel',
  DOCUMENT_MODERATION_ACTION = 'documentModerationAction',
}

export enum DocumentAction {
  TAKE = 'take',
  DROP = 'drop',
  FORCE_TAKE = 'force take',
}

export type DocumentActionButton = {
  label: string;
  type: 'text' | 'default' | 'primary' | 'success' | 'warning' | 'info' | 'danger';
}
